import { encryptData, decryptData } from '../utils/security';

const API_URL = process.env.REACT_APP_API_URL;
const TOKEN_KEY = 'auth_token_encrypted';
const USER_KEY = 'user_data_encrypted';

export const authService = {
  // Login
  login: async (username, password) => {
    const response = await fetch(`${API_URL}/Auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Login failed');
    }

    const data = await response.json();
    
    // Encrypt and store
    sessionStorage.setItem(TOKEN_KEY, encryptData(data.token));
    sessionStorage.setItem(USER_KEY, encryptData(data.user));
    
    return data;
  },

  // Logout
  logout: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
    localStorage.clear();
  },

  // Get token
  getToken: () => {
    const encrypted = sessionStorage.getItem(TOKEN_KEY);
    if (!encrypted) return null;
    return decryptData(encrypted);
  },

  // Get user
  getUser: () => {
    const encrypted = sessionStorage.getItem(USER_KEY);
    if (!encrypted) return null;
    return decryptData(encrypted);
  },

  // Check authentication
  isAuthenticated: () => {
    return !!authService.getToken();
  },

  // Verify token
  verifyToken: async () => {
    const token = authService.getToken();
    if (!token) return false;

    try {
      const response = await fetch(`${API_URL}/Auth/verify`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      return response.ok;
    } catch (error) {
      return false;
    }
  }
};
